import "./styles/devices.scss";

export default function Devices(){
    return(
        <section>
            <h1>Devices page</h1>
        </section>
    )
}